import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { AbstractTopServiceApiService } from '../abstract/abstract-top-service-api-service';
import { TopServiceModel } from '../../../store/self-diagnostic/top-service/model';

const baseUrl = `/api/topServices`;

@Injectable()
export class TopServiceApiService extends AbstractTopServiceApiService {
  private http = inject(HttpClient);

  public getAll(): Observable<InteractorResponse<TopServiceModel[]>> {
    return this.http.get<InteractorResponse<TopServiceModel[]>>(`${baseUrl}`);
  }

  public upPriority(entity: TopServiceModel): Observable<InteractorResponse<TopServiceModel>> {
    return this.http.post<InteractorResponse<TopServiceModel>>(`${baseUrl}/upPriority`, entity);
  }

  public downPriority(entity: TopServiceModel): Observable<InteractorResponse<TopServiceModel>> {
    return this.http.post<InteractorResponse<TopServiceModel>>(`${baseUrl}/downPriority`, entity);
  }

  public save(entity: TopServiceModel): Observable<InteractorResponse<TopServiceModel>> {
    return this.http.post<InteractorResponse<TopServiceModel>>(`${baseUrl}/save`, entity);
  }

  public delete(id: number): Observable<InteractorResponse<TopServiceModel>> {
    return this.http.delete<InteractorResponse<TopServiceModel>>(`${baseUrl}/delete?id=${id}`);
  }

  public sync(): Observable<InteractorResponse<TopServiceModel[]>> {
    return this.http.get<InteractorResponse<TopServiceModel[]>>(`${baseUrl}/sync`);
  }
}
